import { use, useMemo } from 'react';

import { useNewTimedPromotionForClub } from 'src/components/common/promo/use-new-club-timed-promotion';
import { ClubCmsContent } from 'src/content/club-content-consumer';
import { SiteContext } from 'src/context/site-context';
import { BuildType } from 'src/enums/build/build-type';

export const useHeaderPromoRibbonContent = () => {
  const { buildType } = use(SiteContext);
  const { headerContent } = use(ClubCmsContent);

  const { isTimedPromotionReady, timedPromoActiveForCurrentClub, shouldUseHeaderRibbonPromotion } =
    useNewTimedPromotionForClub();

  const getRibbonColourOptions = (buildType: BuildType) => {
    if (buildType === BuildType.MERIDIAN) {
      return timedPromoActiveForCurrentClub?.promotionDetails?.headerPromoRibbon?.meridianColor;
    }
    if (buildType === BuildType.HARBOUR) {
      return timedPromoActiveForCurrentClub?.promotionDetails?.headerPromoRibbon?.harbourColor;
    }
    return timedPromoActiveForCurrentClub?.promotionDetails?.headerPromoRibbon?.color;
  };

  return useMemo(() => {
    return isTimedPromotionReady && shouldUseHeaderRibbonPromotion
      ? ({
          enabled: true,
          ...timedPromoActiveForCurrentClub?.promotionDetails?.headerPromoRibbon,
          color: getRibbonColourOptions(buildType),
          selectedPages: headerContent?.headerPromoRibbon?.enabled
            ? {
                ...headerContent?.headerPromoRibbon?.selectedPages,
                homePage: true,
              }
            : {
                homePage: true,
              },
        } as Queries.HeaderPromoRibbon)
      : headerContent?.headerPromoRibbon;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO why are the dependencies not exhaustive?
  }, [
    headerContent?.headerPromoRibbon,
    isTimedPromotionReady,
    timedPromoActiveForCurrentClub?.promotionDetails?.headerPromoRibbon,
    shouldUseHeaderRibbonPromotion,
  ]);
};
